// extracted by mini-css-extract-plugin
export default {"title":"StepReadyToSubmit_title__JOwH3","question":"StepReadyToSubmit_question__lkhUE","form":"StepReadyToSubmit_form__dEeyR"};